import * as React from 'react';

import classnames from 'classnames';

import {CheckboxGroupContext} from './checkbox-group';

import styles from './checkbox-button.module.css';

type Props = {
    disabled?: boolean;
    value: string;
    isLarge?: boolean;
    children?: React.ReactNode;
};

export class CheckboxButton extends React.Component<Props> {
    render() {
        const styleNames = classnames(styles['input-button'], {
            [styles['is-large']]: this.props.isLarge,
        });

        return (
            <CheckboxGroupContext.Consumer>
                {/* @ts-expect-error */}
                {({name, selectedValues, onChange}) => {
                    const checked = selectedValues.includes(this.props.value);
                    const checkboxId = `${name}-${this.props.value}`;

                    return (
                        <div className={styleNames}>
                            <input
                                id={checkboxId}
                                name={name}
                                type='checkbox'
                                role='checkbox'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, selectedValues, onChange)}
                            />
                            <label htmlFor={checkboxId}>{this.props.children}</label>
                        </div>
                    );
                }}
            </CheckboxGroupContext.Consumer>
        );
    }

    handleChange = (
        e: React.ChangeEvent<any>,
        previousValues: string[],
        onChange: (...args: any) => any
    ) => {
        e.stopPropagation();

        if (e.target.checked) {
            onChange(previousValues.concat([this.props.value]));
        } else {
            onChange(previousValues.filter((item) => item !== this.props.value));
        }
    };
}
